var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { useAuthProvider } from '#context';
import { usePlugFilespaceClient } from '#query-hooks';
import { GuestsKeyFactory } from '../query-key-factories/GuestsKeyFactory';
export const useGetGuest = ({ filespaceId, workspaceId }, email) => {
    _react_refresh_temp_1();
    const { currentUser } = useAuthProvider();
    const { plugFilespaceClient } = usePlugFilespaceClient();
    const query = useQuery({
        queryKey: GuestsKeyFactory.exact({
            email,
            filespaceId,
            workspaceId,
        }),
        queryFn: async () => plugFilespaceClient({
            action: (fsClient) => fsClient.guestLinksManagement().getGuest(email),
            filespaceId,
            workspaceId,
        }),
        enabled: Boolean(currentUser),
        retry: false,
    });
    return query;
};
_react_refresh_temp_1(useGetGuest, "jRMx3r7nIBDWbUBVlsDJFgWprew=", false, () => [useAuthProvider, usePlugFilespaceClient, useQuery]);
